'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dUser$002dFull$002dReference$0024 from "./app.api.-General-Practice-User-Full-Reference$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$37() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$37 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$37 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$37.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$37.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$37;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$37() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$37 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$37 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$37.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$37.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$37.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$37.prototype.apply__O = (function() {
  return $j_app$002eapi$002e$002dGeneral$002dPractice$002dUser$002dFull$002dReference$0024.$m_Lapp_api_GeneralPracticeUserFullReference$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$37 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$37, "app.api.DrugRequestsAcceptedListItem$$anon$37", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$37: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$37 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$37 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$37.js.map
